import { DateTime } from "luxon";
import pluralize from "pluralize";
import { baseplateSizeAbbreviation } from "@brickme/project-core/src/model/project-primitives.ts";
import type { SavedDesignProjectFragment } from "~/api/saved-design-project-fragment.generated.ts";
import fallbackImage from "./saved-design-fallback.jpg";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";

type SavedDesignCellProps = {
	readonly design: SavedDesignProjectFragment;
	readonly status?: "disabled" | "current";
	readonly onClick: () => void;
	readonly onDeleteClick: () => void;
};

function SavedDesignCell({
	design,
	status,
	onClick,
	onDeleteClick,
}: SavedDesignCellProps) {
	const { basePlateSize, numberOfBasePlates, buildNumberOfColours } =
		design.currentPicture;
	const updatedAt = DateTime.fromISO(design.updatedAt);
	const t = useTranslator();
	return (
		<div className="saved-design">
			<button type="button" onClick={onClick} disabled={!!status}>
				<img
					src={design.mediumImageUrl ?? fallbackImage}
					alt={design.updatedAt}
					loading="lazy"
					decoding="async"
				/>
				<div className="saved-design-label">
					{baseplateSizeAbbreviation(basePlateSize)}, {numberOfBasePlates.width}
					x{numberOfBasePlates.height},{" "}
					{pluralize(t("colour"), buildNumberOfColours, true)}
				</div>
				<div className="saved-design-label">
					{t("Saved on {date} {time}", {
						date: updatedAt.toFormat("dd/LL"),
						time: updatedAt.toLocaleString(DateTime.TIME_WITH_SECONDS),
					})}
				</div>
			</button>
			{status === "current" ? (
				<div className="saved-design-label">{t("Currently open")}</div>
			) : (
				<button type="button" className="subtitle" onClick={onDeleteClick}>
					<span
						className="button__text"
						style={{ color: "#8a8a8a", textDecoration: "underline" }}
					>
						{t("Delete")}
					</span>
				</button>
			)}
		</div>
	);
}

export default SavedDesignCell;
